import DaisyBaseServie from './../../../services/DaisyBaseService';
import { navigation } from './navigation.data';

export default class NavigationService extends DaisyBaseServie {
	constructor($injector) {
		super($injector);
		this.$location = $injector.get('$location');
		this.$storage = $injector.get('$localStorage');
	}

	getEndpointInstruction() {
		return this.$storage.routeEndpointInstruction;
	}

	getParentEndpointInstruction() {
		return this.$storage.routeParentEndpointInstruction;
	}

	getRouteEndpointInstruction(currentInstruction) {
		if ( currentInstruction['child'] === null ) {
			this.$storage.routeEndpointInstruction = currentInstruction;
			return currentInstruction;
		}
		
		this.$storage.routeParentEndpointInstruction = currentInstruction;

		for ( let key in currentInstruction ) {
			if( !currentInstruction.hasOwnProperty(key) || key !== 'child' ) {
				continue;
			}

			const instruction = this.getRouteEndpointInstruction(currentInstruction['child']);
			if (instruction) {
				this.$storage.routeEndpointInstruction = instruction;
				return instruction;
			}
		}
		return null;
	}

	getUserModulRoutes(userName) {
		return new Promise((resolve, reject) => {
			resolve(navigation);
		});
	}

	isActiveRoute(component) {
		if (this.getEndpointInstruction().component.componentType.toLowerCase() !== component.toLowerCase()) {
			return false;
		}
		return this.isOnPath('/'+this.getEndpointInstruction().urlPath);
	}

	isParentRoute(component) {
		if (this.getParentEndpointInstruction().component.componentType.toLowerCase() !== component.toLowerCase()) {
			return false;
		}
		return this.isOnPath(this.getParentEndpointInstruction().urlPath);
	}

	isOnPath(path) {
		return this.$location.path().indexOf(path) > -1;
	}
}
